import { useQuery } from '@tanstack/react-query'
import { EmptyState, LoadingState, Tabs } from '@cinesend/ui-kit'
import { useSearchParams } from 'react-router-dom'
import SettingsCard from '../settings_card'
import FieldsByLanguage from './fields_by_language'

const Metadata = ({ asset, airlineID, cycleID }) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const { data: airline, isLoading: isAirlineLoading } = useQuery([`airlines/${airlineID}`])
  const languages = airline?.languages ?? []
  const langFromQuery = searchParams.get('lang')
  const activeLanguage = languages.find((language) => language.ife_code === langFromQuery) ?? languages[0] ?? null

  if (isAirlineLoading) {
    return <LoadingState className='justify-center' />
  }

  if (!languages.length) {
    return (
      <SettingsCard title='Metadata' description='Localized catalog fields for this asset.'>
        <EmptyState title='No languages' detail='This airline has no languages configured.' />
      </SettingsCard>
    )
  }

  return (
    <SettingsCard title='Metadata' description='Fields for this language. Switch languages with the tabs above.'>
      <Tabs
        label='Language'
        className='mb-2'
        value={activeLanguage.ife_code}
        options={languages.map((language) => ({
          value: language.ife_code,
          label: language.eng_description,
        }))}
        onValueChange={(value) => {
          const next = new URLSearchParams(searchParams)
          next.set('lang', value)
          setSearchParams(next, { replace: true })
        }}
      />
      <FieldsByLanguage assetID={asset.id} languageID={activeLanguage.id} cycleID={cycleID} />
    </SettingsCard>
  )
}

export default Metadata
